import { render } from "./[productId].vue?vue&type=template&id=83bcd714"
import script from "./[productId].vue?vue&type=script&lang=js"
export * from "./[productId].vue?vue&type=script&lang=js"

import "./[productId].vue?vue&type=style&index=0&id=83bcd714&lang=scss"

import exportComponent from "../../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__